import type { INumbersRecord } from "app/pages/industry-analysis/players/table/types";

export interface ITHRESHOLD {
    attribute: keyof INumbersRecord;
    value: number;
}

export enum EPlayersType {
    RISING,
    DECLINING,
}

export interface INoData {
    noDataTitle?: string;
    noDataSubtitle?: string;
}
